// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as UnitInfoPage from "./UnitInfoPage.bs.js";
import * as AugmentTooltip from "common/src/tft-static/AugmentTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import Format from "date-fns/format";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as InfoContentSection from "./InfoContentSection.bs.js";

function splitTraitParts(parts) {
  var partsIdx1 = parts.findIndex(function (v) {
        if (typeof v === "number" || v.TAG !== /* Row */11) {
          return false;
        } else {
          return true;
        }
      });
  var partsIdx2 = Belt_Array.sliceToEnd(parts, partsIdx1).findIndex(function (v) {
        if (typeof v === "number" || v.TAG !== /* Row */11) {
          return true;
        } else {
          return false;
        }
      });
  var partsStart = Belt_Array.slice(parts, 0, partsIdx1);
  var match = partsIdx2 === -1 ? [
      Belt_Array.sliceToEnd(parts, partsIdx1),
      []
    ] : [
      Belt_Array.slice(parts, partsIdx1, partsIdx2),
      Belt_Array.sliceToEnd(parts, partsIdx1 + partsIdx2 | 0)
    ];
  return [
          partsStart,
          match[0],
          match[1]
        ];
}

function getAugFileName(info) {
  var split = info.icon.split("/");
  var fileName = Belt_Array.getExn(split, split.length - 1 | 0).toLowerCase();
  return fileName.slice(0, fileName.length - 4 | 0);
}

function textDiff(t1, t2) {
  var s1 = t1.toLowerCase();
  var s1$1 = s1.split("");
  var s2 = t2.toLowerCase();
  var s2$1 = s2.split("");
  var frontDone = {
    contents: false
  };
  var backDone = {
    contents: false
  };
  var frontCount = {
    contents: 0
  };
  var backCount = {
    contents: 0
  };
  var s1l = s1$1.length;
  var s2l = s2$1.length;
  Belt_Array.forEach(Belt_Array.range(0, s1l - 1 | 0), (function (idx) {
          if (!frontDone.contents && idx < s2l) {
            if (Belt_Array.getExn(s1$1, idx) === Belt_Array.getExn(s2$1, idx)) {
              frontCount.contents = frontCount.contents + 1 | 0;
            } else {
              frontDone.contents = true;
            }
          }
          if (!backDone.contents && idx < s2l) {
            if (Belt_Array.getExn(s1$1, (s1l - 1 | 0) - idx | 0) === Belt_Array.getExn(s2$1, (s2l - 1 | 0) - idx | 0)) {
              backCount.contents = backCount.contents + 1 | 0;
            } else {
              backDone.contents = true;
            }
            return ;
          }
          
        }));
  var frontCount$1 = frontCount.contents;
  var backCount$1 = backCount.contents;
  var backCount$2 = Caml.caml_int_min(backCount$1, (
        s1l < s2l ? s1l : s2l
      ) - frontCount$1 | 0);
  var t1s = t1.slice(0, frontCount$1);
  var t1m = t1.slice(frontCount$1, t1.length - backCount$2 | 0);
  var t1e = t1.slice(t1.length - backCount$2 | 0, t1.length);
  var t2s = t2.slice(0, frontCount$1);
  var t2m = t2.slice(frontCount$1, t2.length - backCount$2 | 0);
  var t2e = t2.slice(t2.length - backCount$2 | 0, t2.length);
  return [
          [
            t1s,
            t1m,
            t1e
          ],
          [
            t2s,
            t2m,
            t2e
          ]
        ];
}

function partsDiff(partsBase, parts) {
  var adjPartsBase = [];
  var adjParts = [];
  var highlightParts = [];
  var currIdx = {
    contents: 0
  };
  Belt_Array.forEach(Belt_Array.zip(partsBase, parts), (function (param) {
          var p2 = param[1];
          var p1 = param[0];
          if (Caml_obj.caml_notequal(p1, p2)) {
            var exit = 0;
            if (typeof p1 === "number" || !(p1.TAG === /* Text */3 && !(typeof p2 === "number" || p2.TAG !== /* Text */3))) {
              exit = 1;
            } else {
              var match = textDiff(p1._0, p2._0);
              var match$1 = match[1];
              var t2e = match$1[2];
              var t2m = match$1[1];
              var t2s = match$1[0];
              var match$2 = match[0];
              var t1e = match$2[2];
              var t1m = match$2[1];
              var t1s = match$2[0];
              if (t1m === "" && t2m === "") {
                adjPartsBase.push({
                      TAG: /* Text */3,
                      _0: t1s
                    });
                adjPartsBase.push({
                      TAG: /* Text */3,
                      _0: t1e
                    });
                adjParts.push({
                      TAG: /* Text */3,
                      _0: t2s
                    });
                adjParts.push({
                      TAG: /* Text */3,
                      _0: t2e
                    });
                currIdx.contents = currIdx.contents + 1 | 0;
              } else {
                adjPartsBase.push({
                      TAG: /* Text */3,
                      _0: t1s
                    });
                adjPartsBase.push({
                      TAG: /* Text */3,
                      _0: t1m
                    });
                adjPartsBase.push({
                      TAG: /* Text */3,
                      _0: t1e
                    });
                adjParts.push({
                      TAG: /* Text */3,
                      _0: t2s
                    });
                adjParts.push({
                      TAG: /* Text */3,
                      _0: t2m
                    });
                adjParts.push({
                      TAG: /* Text */3,
                      _0: t2e
                    });
                highlightParts.push(currIdx.contents + 1 | 0);
                currIdx.contents = currIdx.contents + 2 | 0;
              }
            }
            if (exit === 1) {
              highlightParts.push(currIdx.contents);
              adjPartsBase.push(p1);
              adjParts.push(p2);
            }
            
          } else {
            adjPartsBase.push(p1);
            adjParts.push(p2);
          }
          currIdx.contents = currIdx.contents + 1 | 0;
          
        }));
  if (partsBase.length < parts.length) {
    Belt_Array.forEachWithIndex(Belt_Array.sliceToEnd(parts, partsBase.length), (function (idx, p) {
            adjParts.push(p);
            highlightParts.push(idx + adjPartsBase.length | 0);
            
          }));
  }
  if (parts.length < partsBase.length) {
    Belt_Array.forEachWithIndex(Belt_Array.sliceToEnd(partsBase, parts.length), (function (idx, p) {
            adjPartsBase.push(p);
            highlightParts.push(idx + adjParts.length | 0);
            
          }));
  }
  return [
          adjPartsBase,
          adjParts,
          highlightParts
        ];
}

function PbePage$UnitDiffs(Props) {
  var data = Props.data;
  var unitsT = Translation.useT(/* Units */1);
  return Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(Belt_Array.keep(data.units, (function (param) {
                        return param[0].apiName !== "TFT9_Ryze";
                      })), (function (param, param$1) {
                    var u2 = param$1[0];
                    var u1 = param[0];
                    var c1 = Caml.caml_int_compare(Sd.unitTier(u1.apiName), Sd.unitTier(u2.apiName));
                    if (c1 === 0) {
                      return Caml.caml_string_compare(u1.name, u2.name);
                    } else {
                      return c1;
                    }
                  })), (function (idx, param) {
                var info = param[1];
                var info2 = param[0];
                try {
                  var includeAbility = info.ability.desc.toLowerCase() !== info2.ability.desc.toLowerCase();
                  var parts1 = RitoDescription2.parseDesc(info.ability.desc);
                  var parts2 = RitoDescription2.parseDesc(info2.ability.desc);
                  var match = RitoDescription2.diffParts(parts1, parts2);
                  var botUi2 = Belt_Option.map(info2.ability.details, (function (details) {
                          return Belt_Array.mapWithIndex(details, (function (idx, vs) {
                                        if (Belt_Option.isSome((vs == null) ? undefined : Caml_option.some(vs))) {
                                          return [
                                                  unitsT(info2.apiName + "_details_" + String(idx)),
                                                  vs
                                                ];
                                        } else {
                                          return [unitsT(info2.apiName + "_details_" + String(idx))];
                                        }
                                      }));
                        }));
                  var botUi1 = info.ability.botUi;
                  var match$1;
                  if (botUi1 !== undefined && botUi2 !== undefined) {
                    var botUi1$1 = Caml_option.valFromOption(botUi1);
                    match$1 = [
                      Belt_Array.keep(botUi1$1, (function (v) {
                              return !Belt_Array.some(botUi2, (function (v2) {
                                            return Caml_obj.caml_equal(v, v2);
                                          }));
                            })),
                      Belt_Array.keep(botUi2, (function (v) {
                              return !Belt_Array.some(botUi1$1, (function (v2) {
                                            return Caml_obj.caml_equal(v, v2);
                                          }));
                            }))
                    ];
                  } else {
                    match$1 = [
                      undefined,
                      undefined
                    ];
                  }
                  var odd = idx % 2 === 1;
                  return React.createElement(React.Fragment, {
                              children: null,
                              key: info.apiName
                            }, React.createElement("div", {
                                  className: "px-3 pl-5 pt-12 sm:py-5 mt-4 sm:mt-0 sm:w-[120px] flex gap-1 flex-row sm:flex-col sm:justify-center items-center col-span-2 sm:col-span-1" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, React.createElement(UnitTooltip.make, {
                                      unit: info.apiName,
                                      children: React.createElement(UnitImage.make, {
                                            unitId: info.apiName,
                                            size: 36
                                          })
                                    }), React.createElement("div", {
                                      className: "text-center leading-tight"
                                    }, React.createElement(UnitName0.make, {
                                          unit: info.apiName
                                        }))), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, includeAbility ? React.createElement("div", {
                                        className: "pb-1"
                                      }, React.createElement("div", {
                                            className: "leading-tight"
                                          }, React.createElement(RitoDescription2.Parts.make, {
                                                parts: match[1],
                                                highlightParts: match[3]
                                              })), React.createElement(UnitTooltip.AbilityDetailsRaw.make, {
                                            details: match$1[1]
                                          })) : null, info.stats.damage !== info2.stats.damage ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatAd.make, {
                                            unitId: info.apiName,
                                            info: info2
                                          })) : null, info.stats.attackSpeed !== info2.stats.attackSpeed ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatAs.make, {
                                            info: info2
                                          })) : null, info.stats.armor !== info2.stats.armor ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatArmor.make, {
                                            info: info2
                                          })) : null, info.stats.magicResist !== info2.stats.magicResist ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatMr.make, {
                                            info: info2
                                          })) : null, info.stats.hp !== info2.stats.hp ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatHp.make, {
                                            unitId: info.apiName,
                                            info: info2
                                          })) : null, info.stats.range !== info2.stats.range ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatRange.make, {
                                            info: info2
                                          })) : null, info.stats.initialMana !== info2.stats.initialMana || info.stats.mana !== info2.stats.mana ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatMana.make, {
                                            info: info2
                                          })) : null), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, includeAbility ? React.createElement("div", {
                                        className: "pb-2"
                                      }, React.createElement("div", {
                                            className: "leading-tight"
                                          }, React.createElement(RitoDescription2.Parts.make, {
                                                parts: match[0],
                                                highlightParts: match[2]
                                              })), React.createElement(UnitTooltip.AbilityDetailsRaw.make, {
                                            details: match$1[0]
                                          })) : null, info.stats.damage !== info2.stats.damage ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatAd.make, {
                                            unitId: info.apiName,
                                            info: info
                                          })) : null, info.stats.attackSpeed !== info2.stats.attackSpeed ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatAs.make, {
                                            info: info
                                          })) : null, info.stats.armor !== info2.stats.armor ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatArmor.make, {
                                            info: info
                                          })) : null, info.stats.magicResist !== info2.stats.magicResist ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatMr.make, {
                                            info: info
                                          })) : null, info.stats.hp !== info2.stats.hp ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatHp.make, {
                                            unitId: info.apiName,
                                            info: info
                                          })) : null, info.stats.range !== info2.stats.range ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatRange.make, {
                                            info: info
                                          })) : null, info.stats.initialMana !== info2.stats.initialMana || info.stats.mana !== info2.stats.mana ? React.createElement("div", {
                                        className: "pt-[2px]"
                                      }, React.createElement(UnitInfoPage.StatMana.make, {
                                            info: info
                                          })) : null));
                }
                catch (raw_e){
                  var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                  console.log(e);
                  return null;
                }
              }));
}

var UnitDiffs = {
  make: PbePage$UnitDiffs
};

function PbePage$TraitDiffs(Props) {
  var data = Props.data;
  var idx = {
    contents: 0
  };
  return Belt_Array.map(Belt_SortArray.stableSortBy(data.traits, (function (param, param$1) {
                    return Caml.caml_string_compare(param[0].name, param$1[0].name);
                  })), (function (param) {
                var info = param[1];
                var traitId = info.apiName;
                var parts1 = RitoDescription2.parseDesc(info.desc);
                var parts2 = RitoDescription2.parseDesc(param[0].desc);
                var match = RitoDescription2.diffParts(parts1, parts2);
                var highlights2 = match[3];
                var highlights1 = match[2];
                var odd = idx.contents % 2 === 1;
                if (highlights1.length === 0 && highlights2.length === 0) {
                  return null;
                } else {
                  idx.contents = idx.contents + 1 | 0;
                  return React.createElement(React.Fragment, {
                              children: null,
                              key: info.apiName
                            }, React.createElement("div", {
                                  className: "px-3 pl-5 pt-12 sm:py-5 mt-4 sm:mt-0 sm:w-[120px] flex gap-1 flex-row sm:flex-col sm:justify-center items-center mt-12 sm:mt-0 col-span-2 sm:col-span-1" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, React.createElement(TraitTooltip.make, {
                                      trait: traitId,
                                      children: React.createElement(TraitImage.PlainIcon.make, {
                                            traitId: traitId,
                                            size: 36
                                          })
                                    }), React.createElement("div", {
                                      className: "pt-1 text-center leading-tight"
                                    }, React.createElement(TraitName0.make, {
                                          trait: traitId
                                        }))), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, React.createElement(RitoDescription2.Parts.make, {
                                      parts: match[1],
                                      highlightParts: highlights2
                                    })), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, React.createElement(RitoDescription2.Parts.make, {
                                      parts: match[0],
                                      highlightParts: highlights1
                                    })));
                }
              }));
}

var TraitDiffs = {
  make: PbePage$TraitDiffs
};

function PbePage$ItemDiffs(Props) {
  var data = Props.data;
  var idx = {
    contents: 0
  };
  return Belt_Array.map(Belt_SortArray.stableSortBy(data.items, (function (param, param$1) {
                    return Caml.caml_int_compare(param[0].id, param$1[0].id);
                  })), (function (param) {
                var info = param[1];
                var info2 = param[0];
                var statsDiff = Belt_Array.some([
                      "AD",
                      "AS",
                      "AP",
                      "Mana",
                      "Armor",
                      "MagicResist",
                      "Health",
                      "CritChance",
                      "{c4b5579c}"
                    ], (function (key) {
                        return Caml_obj.caml_notequal(Js_dict.get(info.effects, key), Js_dict.get(info2.effects, key));
                      }));
                var parts1 = RitoDescription2.parseDesc(info.desc);
                var parts2 = RitoDescription2.parseDesc(info2.desc);
                var match = RitoDescription2.diffParts(parts1, parts2);
                var highlights2 = match[3];
                var highlights1 = match[2];
                var odd = idx.contents % 2 === 1;
                var showDescs = highlights1.length !== 0 || highlights2.length !== 0;
                if (highlights1.length === 0 && highlights2.length === 0 && !statsDiff) {
                  return null;
                } else {
                  idx.contents = idx.contents + 1 | 0;
                  return React.createElement(React.Fragment, {
                              children: null,
                              key: String(info.id)
                            }, React.createElement("div", {
                                  className: "px-3 pl-5 pt-12 sm:py-5 mt-4 sm:mt-0 sm:w-[120px] flex gap-1 flex-row sm:flex-col sm:justify-center items-center mt-12 sm:mt-0 col-span-2 sm:col-span-1" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, React.createElement(ItemTooltip.make, {
                                      itemId: info.sid,
                                      children: React.createElement(ItemImage.make, {
                                            itemId: info.sid,
                                            size: 36
                                          })
                                    }), React.createElement("div", {
                                      className: "text-center pt-1 leading-tight"
                                    }, info2.name)), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, showDescs ? React.createElement(RitoDescription2.Parts.make, {
                                        parts: match[1],
                                        highlightParts: highlights2
                                      }) : null, statsDiff ? React.createElement("div", {
                                        className: "pt-2"
                                      }, React.createElement(ItemTooltip.BaseStats.make, {
                                            item: info2
                                          })) : null), React.createElement("div", {
                                  className: "px-4 pr-5 py-5 leading-tight" + (
                                    odd ? " bg-bg2" : ""
                                  )
                                }, showDescs ? React.createElement(RitoDescription2.Parts.make, {
                                        parts: match[0],
                                        highlightParts: highlights1
                                      }) : null, statsDiff ? React.createElement("div", {
                                        className: "pt-2"
                                      }, React.createElement(ItemTooltip.BaseStats.make, {
                                            item: info
                                          })) : null));
                }
              }));
}

var ItemDiffs = {
  make: PbePage$ItemDiffs
};

function PbePage$AugmentDiffs(Props) {
  var data = Props.data;
  TftSet.use(undefined);
  return Belt_Array.mapWithIndex(Belt_Array.keep(Belt_SortArray.stableSortBy(data.augments, (function (param, param$1) {
                        return Caml.caml_string_compare(param[0].name, param$1[0].name);
                      })), (function (param) {
                    return !param[0].sid.includes("Legend_TomeOfTraits");
                  })), (function (idx, param) {
                var info = param[1];
                var info2 = param[0];
                var parts1 = RitoDescription2.parseDesc(info.desc);
                var parts2 = RitoDescription2.parseDesc(info2.desc);
                var match = RitoDescription2.diffParts(parts1, parts2);
                return React.createElement(React.Fragment, {
                            children: React.createElement(React.Fragment, undefined, React.createElement("div", {
                                      className: "px-3 pl-5 pt-12 sm:py-5 mt-4 sm:mt-0 sm:w-[120px] flex gap-1 flex-row sm:flex-col sm:justify-center items-center mt-12 sm:mt-0 col-span-2 sm:col-span-1" + (
                                        idx % 2 === 1 ? " bg-bg2" : ""
                                      )
                                    }, React.createElement(AugmentTooltip.make, {
                                          id: info.sid,
                                          children: React.createElement(AugmentImage.make, {
                                                augId: info.sid,
                                                size: 36
                                              })
                                        }), React.createElement("div", {
                                          className: "text-center pt-1 leading-tight"
                                        }, info2.name)), React.createElement("div", {
                                      className: "px-4 pr-5 py-5 leading-tight" + (
                                        idx % 2 === 1 ? " bg-bg2" : ""
                                      )
                                    }, React.createElement(RitoDescription2.Parts.make, {
                                          parts: match[1],
                                          highlightParts: match[3]
                                        })), React.createElement("div", {
                                      className: "px-4 pr-5 py-5 leading-tight" + (
                                        idx % 2 === 1 ? " bg-bg2" : ""
                                      )
                                    }, React.createElement(RitoDescription2.Parts.make, {
                                          parts: match[0],
                                          highlightParts: match[2]
                                        }))),
                            key: String(info.id)
                          });
              }));
}

var AugmentDiffs = {
  make: PbePage$AugmentDiffs
};

function PbePage(Props) {
  var data = Props.data;
  var updated = Props.updated;
  var updated$1 = new Date(updated);
  return React.createElement(React.Fragment, undefined, React.createElement(InfoContentSection.make, {
                  children: null,
                  noPadding: true
                }, React.createElement("div", {
                      className: "p-6 leading-tight"
                    }, React.createElement("div", undefined, "Datamined changes from current PBE release. Be aware that these changes are tentative and they might be changed or even reverted prior to the live patch."), React.createElement("div", {
                          className: "flex items-center pt-4 gap-3"
                        }, React.createElement("div", undefined, "Datamining only captures numerical changes. It doesn't capture changes to mechanics and bugfixes that may also significantly affect balance.")), React.createElement("div", {
                          className: "flex items-center pt-4 gap-3"
                        }, React.createElement("div", undefined, "Due to the nature of how the datamining works it may also includes some of the changes that are already added to the live version in the most recent patch.\n      "))), React.createElement("div", {
                      className: "px-6 py-2"
                    }, "Updated: " + Format(updated$1, "MMM d ha")), React.createElement("div", {
                      className: "grid gap-4 grid-cols-2 sm:grid-cols-[120px_1fr_1fr] bg-bg0 text-[20px] font-montserrat font-semibold pt-[14px] pb-3 sticky z-10 top-[48px] md:top-[92px]"
                    }, React.createElement("div", {
                          className: "hidden sm:block"
                        }), React.createElement("div", {
                          className: "text-center"
                        }, "Live"), React.createElement("div", {
                          className: "text-center"
                        }, "PBE")), React.createElement("div", {
                      className: "grid grid-cols-2 sm:grid-cols-[120px_1fr_1fr] pt-3"
                    }, React.createElement(PbePage$UnitDiffs, {
                          data: data
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement(PbePage$TraitDiffs, {
                          data: data
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement(PbePage$ItemDiffs, {
                          data: data
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement("div", {
                          className: "h-10"
                        }), React.createElement(PbePage$AugmentDiffs, {
                          data: data
                        }))));
}

var make = PbePage;

export {
  splitTraitParts ,
  getAugFileName ,
  textDiff ,
  partsDiff ,
  UnitDiffs ,
  TraitDiffs ,
  ItemDiffs ,
  AugmentDiffs ,
  make ,
  
}
/* Sd Not a pure module */
